import axios from 'axios';

const userService = {
	fetchAllRoles: id => axios.get(`api/v1/roles/${id}/roles`),
	createRole: params => axios.post(`api/v1/roles`, params),
	fetchRolePolicies: id => axios.get(`api/v1/applications/${id}/rolePolicies`),
	createRolePolicy: params => axios.post(`api/v1/roles/addRolePolicy`, params),
	updateRolePolicy: params => axios.put(`api/v1/policies`, params),
	deleteRolePolicy: params => axios.delete(`api/v1/roles/removeRolePolicy`, { data: params })
};
export default userService;
